import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { ProvidedProfile } from '@/features/jobs/info-gathering/supporting-item-input'

/**
 * Props for {@link PersonalInfoSupportingItemInput}.
 */
export type PersonalInfoSupportingItemInputProps =
  ModelProps<PersonalInfoSupportingItemInput> & { type: 'PersonalInfo' }

/**
 * Supporting item input for personal information.
 */
export class PersonalInfoSupportingItemInput extends Model<PersonalInfoSupportingItemInput> {
  /**
   * The provided profile, if any.
   */
  @observable.struct accessor provided: ProvidedProfile | null = null
}
